module.exports = __webpack_public_path__ + "img/case_c919.426cc87e.jpg";